import React, { FC } from "react";
import { useSelector } from "react-redux";
import ForkliftDetailsContainer from "./ForkliftDetails/ForkliftDetailsContainer";
import LightingDetailsParent from "./LightingDetails/LightingDetailsParent";
import PeopleDetailsContainer from "./PeopleDetails/PeopleDetailsContainer";
import InfoText from "../../../components/InfoText/InfoText";

const AdditionalLoadsContainer: FC = () => {
  const additionalLoadsEnabled: boolean = useSelector((state: any) => {
    return state.heatLoad.formSections.additionalLoadsEnabled;
  });

  return (
    <div data-testid="additional-loads">
      {additionalLoadsEnabled && (
        <>
          <PeopleDetailsContainer />

          <LightingDetailsParent />

          <ForkliftDetailsContainer />
        </>
      )}
      {!additionalLoadsEnabled && (
        <InfoText testid="no-additional-loads">
          Add your Additional loads after you’ve defined your room and
          transmission details.
        </InfoText>
      )}
    </div>
  );
};

export default AdditionalLoadsContainer;
